var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M223.209 145.234V192.031C223.209 213.594 205.709 231.094 184.147 231.094H115.865C94.3027 231.094 76.8027 213.594 76.8027 192.031V145.781C82.7402 152.188 91.1777 155.859 100.318 155.859C110.162 155.859 119.615 150.938 125.553 143.047C130.865 150.938 139.928 155.859 150.006 155.859C160.006 155.859 168.912 151.172 174.303 143.359C180.319 151.094 189.616 155.859 199.303 155.859C208.756 155.859 217.35 152.031 223.209 145.234Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.355 66.0156H126.48L120.699 123.516C120.23 128.828 121.011 133.828 122.964 138.359C127.496 148.984 138.121 155.859 149.996 155.859C162.027 155.859 172.418 149.141 177.105 138.438C178.512 135.078 179.371 131.172 179.449 127.188V125.703L173.355 66.0156Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M230.936 120.859L228.67 99.2188C225.389 75.625 214.686 66.0156 191.795 66.0156H161.795L167.576 124.609C167.654 125.391 167.732 126.25 167.732 127.734C168.201 131.797 169.451 135.547 171.326 138.906C176.951 149.219 187.889 155.859 199.295 155.859C209.686 155.859 219.061 151.25 224.92 143.125C229.607 136.875 231.717 128.984 230.936 120.859Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M107.731 66.0156C84.7624 66.0156 74.1374 75.625 70.778 99.4531L68.6687 120.937C67.8874 129.297 70.153 137.422 75.0749 143.75C81.0124 151.484 90.153 155.859 100.309 155.859C111.716 155.859 122.653 149.219 128.2 139.062C130.231 135.547 131.559 131.484 131.95 127.266L138.044 66.0937H107.731V66.0156Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.916 186.406C134.994 187.422 127.494 195.859 127.494 205.859V231.094H172.416V208.594C172.494 192.266 162.884 184.531 144.916 186.406Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletEmpty);
export default __webpack_public_path__ + "static/media/outletEmpty.b11cda301bc2d0cb7eea61b66808263d.svg";
export { ForwardRef as ReactComponent };